import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    description: 'call to action for shipstation connect settings page',
    defaultMessage: 'Get Connected to your devices!',
    id: 'Wes7SI',
  },
  callDescription: {
    description: 'additional information about shipstation connect',
    defaultMessage:
      'ShipStation Connect allows you to seamlessly utilize a computers printers, scanners and more. Devices can be shared with any other user of your organization, so they can be accessed from any computer, anywhere!',
    id: 'TlGNzg',
  },
  notInstalledHeader: {
    description: 'header for if the user has not installed connect',
    defaultMessage: 'If you have not installed ShipStation Connect...',
    id: 'jYSNFq',
  },
  notInstalledDesc: {
    description: 'description for if the user has not installed connect',
    defaultMessage:
      "Install ShipStation Connect below and you'll be able to seamlessly access and share your computer's devices from within ShipStation.",
    id: '2r2S2+',
  },
  installedHeader: {
    description: 'header if the user has installed connect',
    defaultMessage: 'If you already have ShipStation Connect installed on your computer...',
    id: '69EHBH',
  },
  installedDesc: {
    description: 'description if the user has installed connect',
    defaultMessage: "Launch ShipStation Connect on your computer to activate it. You'll then be able to manage it here.",
    id: 'jhMdMt',
  },
  note: {
    description: 'extra note about connect',
    defaultMessage: '<b>Please Note:</b> Only the user that installed ShipStation Connect can manage it.',
    id: '5MMhrQ',
  },
  macInstallButton: {
    description: 'button to download connect',
    defaultMessage: 'Install ShipStation Connect for Mac',
    id: 'muzmwn',
  },
  winInstallButton: {
    description: 'button to download connect for windows',
    defaultMessage: 'Install ShipStation Connect for Windows',
    id: 'erA/Jf',
  },
  shipstationConnect: {
    description: 'header when active',
    defaultMessage: 'ShipStation Connect',
    id: 'uBOcJv',
  },
  yourDevices: {
    description: 'a description of the page',
    defaultMessage: 'Your Devices',
    id: 'kJxd6D',
  },
  info: {
    description: 'more description',
    defaultMessage: 'The following workstations were activated by you and can be managed by you as well as other account administrators.',
    id: '5DMDEp',
  },
  disabled: {
    description: 'column header for disabled checkboxs',
    defaultMessage: 'Disabled',
    id: 'O4JYYf',
  },
  shared: {
    description: 'column header for shared checkboxs',
    defaultMessage: 'Shared',
    id: 'r6jC8r',
  },
  printers: {
    description: 'header for list of printers',
    defaultMessage: 'Printers',
    id: '1OTABP',
  },
  scales: {
    description: 'header for list of scales',
    defaultMessage: 'Scales',
    id: 'To6dOT',
  },
  activatedBy: {
    description: 'information on the user that activated this workstation',
    defaultMessage: 'Activated by {userName}.',
    id: 'H9raDz',
  },
  deactivate: {
    description: 'link to deactivate workstation',
    defaultMessage: 'Deactivate this workstation',
    id: 'pA+olb',
  },
  additionalInstall: {
    description: 'header for installing shipstation again',
    defaultMessage: 'Additional Installations',
    id: 'jq20d8',
  },
  additionalInstallDesc: {
    description: 'description for additional installations',
    defaultMessage: "If you'd like to install ShipStation Connect on an additional computer, you can download it below.",
    id: '43jQiA',
  },
  edit: {
    description: 'prompt for editing a device name',
    defaultMessage: 'edit',
    id: 'S7y4UV',
  },
  editDeviceHeader: {
    description: 'header text for modal to edit printer settings',
    defaultMessage: 'Edit Device Settings',
    id: 'pAPd3i',
  },
  cancel: {
    description: 'button to close the edit printer/scale modal',
    defaultMessage: 'Cancel',
    id: 'VnVRHC',
  },
  save: {
    description: 'button to save printer/scale settings and close the edit modal',
    defaultMessage: 'Save',
    id: '9ZFgoV',
  },
  editNameLabel: {
    description: 'label for the input to edit a device name',
    defaultMessage: 'Name',
    id: 'Tm+5TB',
  },
  disabledInfo: {
    description: 'description of what disabled means for a printer',
    defaultMessage: "Disabled devices won't be visible in ShipStation to you or anyone in your organization.",
    id: 'C8Jt/S',
  },
  sharedInfo: {
    description: 'description of what shared means for a printer',
    defaultMessage: 'Allow other users on your ShipStation account to access and utilize the device from anywhere.',
    id: 'fsKyTY',
  },
  noScales: {
    description: 'a message when a user has no detectable scales',
    defaultMessage: 'No Scales connected',
    id: 'p4SmVc',
  },
  noPrinters: {
    description: 'a message when a user has no detectable printers',
    defaultMessage: 'No Printers connected',
    id: 'ZXXVgf',
  },
  zplPrintSpeed: {
    description: 'printer setting for zpl speed',
    defaultMessage: 'ZPL print speed override',
    id: 'jMN5C6',
  },
  zplChunkSize: {
    description: 'printer setting for zpl chunk size',
    defaultMessage: 'ZPL chunk size override',
    id: 'yCv/Gi',
  },
  zplInvert: {
    description: 'printer setting for zpl invert',
    defaultMessage: 'ZPL 180˚ Rotation',
    id: 'CjXva5',
  },
  zplPrintSpeedRemoval: {
    description: 'printer setting for ignoring ZPL speed',
    defaultMessage: 'Ignore ZPL print speed',
    id: '7zfgyO',
  },
  ssTimeout: {
    description: 'scale setting for ssTimeout',
    defaultMessage: 'ShipStation Timeout',
    id: 'H0LbMS',
  },
  deviceTimeout: {
    description: 'scale setting for deviceTimeout',
    defaultMessage: 'Device Timeout',
    id: 'EueKEt',
  },
  weight1Byte: {
    description: 'scale setting for weight1Byte',
    defaultMessage: 'Weight Byte 1',
    id: 'UXN4XS',
  },
  weight2Byte: {
    description: 'scale setting for weight2Byte',
    defaultMessage: 'Weight Byte 2',
    id: 'dhL8Ki',
  },
  weight1Factor: {
    description: 'scale setting for weight1Factor',
    defaultMessage: 'Weight Factor 1',
    id: 'mbmdkg',
  },
  weight2Factor: {
    description: 'scale setting for weight2Factor',
    defaultMessage: 'Weight Factor 2',
    id: '6JcTbh',
  },
  readWait: {
    description: 'scale setting for readWait',
    defaultMessage: 'Read Wait',
    id: 'GToRav',
  },
  retries: {
    description: 'scale setting for retries',
    defaultMessage: 'Retries',
    id: 'IhQRJE',
  },
  model: {
    description: 'dimensionalizer model',
    defaultMessage: 'Model',
    id: 'K9dC3E',
  },
  host: {
    description: 'dimensionalizer ip address',
    defaultMessage: 'IP Address',
    id: 'v283Uv',
  },
  port: {
    description: 'dimensionalizer port',
    defaultMessage: 'Port',
    id: 'GFzn1A',
  },
  restoreToDefaults: {
    description: 'message for a button to restore settings to defaults',
    defaultMessage: 'Restore to defaults',
    id: '7m/q33',
  },
  configureHighCapMode: {
    description: 'message for a button to configure high capacity mode',
    defaultMessage: 'Configure settings for high capacity mode',
    id: 'hNHzkF',
  },
  readingFromScale: {
    description: 'Message to let the user know we are reading their scale',
    defaultMessage: 'Reading From scale',
    id: 'C2cP8g',
  },
  readScaleSuccess: {
    description: 'message to let the user know reading from their scale was successfull',
    defaultMessage: 'Weight from Scale',
    id: 'UDy9H2',
  },
  readDimensionalizerSuccess: {
    description: 'message to let the user know reading from their scale was successfull',
    defaultMessage: 'Weight and Dimensions from Dimensionalizer',
    id: 'ycfwp4',
  },
  dimensionlizerSuccessMessage: {
    description: 'Dimensions unit number e.g. 1in X 2in X 3in',
    defaultMessage: '{length, number, ::measure-unit/inch} X {width, number, ::measure-unit/inch} X {height, number, ::measure-unit/inch}',
    id: 'rZg3VR',
  },
  readScaleFailure: {
    description: 'message to let the user know reading from their scale failed',
    defaultMessage: 'Unable to read weight from scale.',
    id: 'oSHGeJ',
  },
  disabledInfoTooltip: {
    description: 'info about the disabled checkboxes',
    defaultMessage: "Disabled devices won't be visible in ShipStation to you or anyone in your organization.",
    id: 'L3BSer',
  },
  sharedInfoTooltip: {
    description: 'info about the shared checkboxes',
    defaultMessage: 'Allow other users on your ShipStation account to access and utilize the device from anywhere',
    id: '/ULtxt',
  },
  readFromScaleTitle: {
    description: 'title for the button to read from a scale',
    defaultMessage: 'read',
    id: 'ETDKlR',
  },
  otherUsersDevices: {
    description: 'Category for Connect workstations that are not for the active user',
    defaultMessage: "Other Users' Devices",
    id: 'h+U1v8',
  },
  connectOfflineError: {
    description: 'Error message when ss connect is offline',
    defaultMessage:
      'The printer, <b>{selectedPrinterName}</b>, connected to ShipStation Connect workstation <b>{workstationName}</b> is currently offline.',
    id: 'U5X6Bf',
  },
  navigateToPrintSettings: {
    description: 'text for a button that will navigate to the Print Settings page',
    defaultMessage: 'View and update your Print Settings',
    id: 'rje4MK',
  },
  printingErrorContent: {
    description: 'ssConnectEpics.printingErrorContent',
    defaultMessage: 'Printing Error - { printJobError }',
    id: 'JxuMbf',
  },
  printingErrorWorkstationIdentification: {
    description: 'error text that tells the user which "workstation" of theirs is reporting the error',
    defaultMessage:
      'The ShipStation Connect workstation <b>{workstationName}</b> returned the following error in response to the print request:',
    id: '25unlI',
  },
  printingErrorCopyToClipboardAriaLabel: {
    description: 'ARIA label for a copy to clipboard button',
    defaultMessage: 'Click here to copy the error to the clipboard',
    id: '6ZpFHq',
  },
});

export default messages;
